import React from "react";
import "./TouchFAB.module.css";

export interface TouchFABProps {
  icon: React.ReactNode;
  onClick: () => void;
  position?: "bottom-right" | "bottom-left" | "bottom-center";
  label?: string;
  color?: string;
  className?: string;
  disabled?: boolean;
}

export const TouchFAB: React.FC<TouchFABProps> = ({
  icon,
  onClick,
  position = "bottom-right",
  label,
  color = "#2c1561",
  className = "",
  disabled = false
}) => {
  const getPositionClasses = () => {
    switch (position) {
      case "bottom-left":
        return "bottom-6 left-6";
      case "bottom-center":
        return "bottom-6 left-1/2 -translate-x-1/2";
      case "bottom-right":
      default:
        return "bottom-6 right-6";
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        fixed z-40
        min-w-[56px] min-h-[56px]
        rounded-full
        shadow-lg hover:shadow-xl
        transition-all duration-200
        flex items-center justify-center gap-2
        text-white font-medium
        active:scale-95
        disabled:opacity-50 disabled:cursor-not-allowed
        ${getPositionClasses()}
        ${label ? "px-6" : "w-14 h-14"}
        ${className}
      `}
      style={{
        backgroundColor: disabled ? "#9ca3af" : color
      }}
      aria-label={label || "Floating action button"}
    >
      <span className="flex items-center justify-center">{icon}</span>
      {label && (
        <span className="text-sm whitespace-nowrap" style={{ color: "white" }}>
          {label}
        </span>
      )}
    </button>
  );
};
